import GettingStartedContainer from './getting-started-container';

export default GettingStartedContainer;
